import { UnitOfMeasurement } from './unit-of-measurement.interface';

export interface Item {
    id?: string;
    itemCode: string;
    itemName: string;
    /** Q3: optional scannable barcode, unique per company. Send an empty string to clear it. */
    barcode?: string | null;
    description: string;
    lotTracked: boolean;
    itemCategoryId: string;
    itemCategory?: {
        id: string;
        itemCategoryName: string;
        /** "Parent › Sub" for a sub-category. */
        fullName?: string | null;
        description: string;
    };
    unitOfMeasurementId?: string;
    unit?: UnitOfMeasurement;
    standardUnitCost?: number;
    /** B4-A: HS code (prefills Mushak 4.3 declarations). */
    hsCode?: string;
    // ---- FW-2A: product/service catalogue ----
    itemKind?: ItemKind;
    sellable?: boolean;
    salePrice?: number | null;
    defaultRevenueAccountId?: string | null;
    defaultTaxCodeId?: string | null;
    // ---- end FW-2A ----
    /** F6a: expiry-tracked (needs lotTracked): every receipt records an expiry date; issue and sale draw FEFO. */
    expiryTracked?: boolean;
    /** F6b: serial-tracked: every unit carries a serial number, captured on receipt and picked on issue/sale. */
    serialTracked?: boolean;
    /** G6-0: read-only, derived on the server: FIFO_LOT when lot-tracked, else MOVING_AVERAGE. */
    costingMethod?: 'FIFO_LOT' | 'MOVING_AVERAGE';
    /** Item type override; empty = use the category default. */
    nature?: ItemNature | null;
    /** Write-only: true clears the override so the item follows its category. */
    useCategoryNature?: boolean;
    /** Read-only: the type that applies (item override, else category, else Consumable). */
    effectiveNature?: ItemNature;
}

export type ItemNature = 'CONSUMABLE' | 'RETURNABLE' | 'FIXED_ASSET';

export const ITEM_NATURE_LABEL: Record<ItemNature, string> = {
    CONSUMABLE: 'Consumable',
    RETURNABLE: 'Returnable',
    FIXED_ASSET: 'Fixed asset',
};


export type ItemKind = 'STOCK' | 'SERVICE' | 'KIT';   // F6c: KIT

export interface ItemResponse {
    content: Item[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            sorted: boolean;
            empty: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    sort: {
        sorted: boolean;
        empty: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}
